import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import api from '../../services/api';
import { CardReserva, CardChegada, CardTitleProgramacao, CardPartida, CardFaleConosco, CardServicos } from './components';
import CustomizedTimeline from './CustomizedTimeline';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

/*Novo - Ajustado o formatHora para não ser impactato pelo timezone do navegador*/
function formatHoraSemTimezone(value) {
  if (!value) return '';

  const str = String(value).trim();


  const horaDireta = str.match(/^(\d{1,2}):(\d{2})/);
  if (horaDireta) {
    return `${horaDireta[1].padStart(2, '0')}:${horaDireta[2]}`;
  }


  const horaEmTexto = str.match(/T?(\d{2}):(\d{2})(?::\d{2})?/);
  if (horaEmTexto) {
    return `${horaEmTexto[1]}:${horaEmTexto[2]}`;
  }

  return str.substring(0, 5);
}

function formatDataSemTimezone(value) {
  if (!value) return '';

  const str = String(value).trim();


  if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
    return str;
  }


  const dataIso = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dataIso) {
    return `${dataIso[3]}/${dataIso[2]}/${dataIso[1]}`;
  }


  const dataPonto = str.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
  if (dataPonto) {
    return `${dataPonto[1]}/${dataPonto[2]}/${dataPonto[3]}`;
  }

  return str;
}

const MenuProgramacao = () => {
  const classes = useStyles();
  const handleChange = event => {
    event.persist();
    //console.log('escolheu mes');
    window.location.reload();
  }

  /* Dados da OS */
  const [os, setDadosOS] = useState({});
  const [passengers, setPassengers] = useState([]);
  const [itens, setItensLocalizador] = useState([]);
  const [cfgappcli, setCfgAppcli] = useState([])

  /* carrega dados da OS */
  async function loadDadosOS() {
    const codOS = sessionStorage.getItem('codOS');
    const aURL = '/os/' + codOS;
    try {
      console.log('código da OS consultada é:' + codOS);
      const response = await api.get(aURL);
      setDadosOS(response.data[0]);
      setPassengers(response.data[0].paxgeral);
      //console.log(response.data[0].paxgeral)
    } catch (error) {
      console.log(error);
    }
  }

  /* carrega itens do localizador */
  async function loadItensLocalizador() {
    const localizador = sessionStorage.getItem('localizador');
    const aURL = '/appcli/itensOSByLocalizador';
    try {
      const response = await api.post(aURL, { localizador: localizador });

      const itensFormatados = response.data.map(item => ({
        ...item,
        dataservico: formatDataSemTimezone(item.dataservico),
        dataapresentacao: formatDataSemTimezone(item.dataapresentacao),
        horainservico: formatHoraSemTimezone(item.horainservico),
        horaapresentacao: formatHoraSemTimezone(item.horaapresentacao)
      }));

      console.log('itens: ' + JSON.stringify(itensFormatados));
      setItensLocalizador(itensFormatados);

      console.log('o que está no log original da API: ' + JSON.stringify(response.data));

    } catch (error) {
      console.log(error);
    }
  }

  /* carrega configurações app cli */
  async function loadDadosCfgAppCli() {
    //const codOS = sessionStorage.getItem('codOS');
    const aURL = '/appcli/configuracoes/1';
    try {
      const response = await api.get(aURL);
      setCfgAppcli(response.data[0]);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    loadDadosOS();
    loadItensLocalizador();
    loadDadosCfgAppCli();
  }, []);

  return (
    <div className={classes.root}>

      <CustomizedTimeline
        datain={os.datain}
        dataout={os.dataout}
        itens={itens}
      />
      <CardTitleProgramacao />

      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          lg={3}
          sm={6}
          xl={6}
          xs={12}
        >
          <CardReserva
            nroos={os.nroos}
            nomefantcli={os.nomefantcli}
            idiomaos={os.idiomaos}
            passageiros={passengers}
            hospedagemprincipal={os.nomefanthotel}
          />

        </Grid>

        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <CardServicos
            servicos={itens}
          />

        </Grid>

        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          {/*Kadmiel - Ajustada rota para carregar os novos campos*/}
          <CardFaleConosco
            faleconosco={cfgappcli?.faleconosco}
            msgwhatsfone={cfgappcli?.msgwhatsfone}
            msgwhatsperso={cfgappcli?.msgwhatsperso}
          />

        </Grid>


      </Grid>
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >

        </Grid>

      </Grid>


    </div>
  );
};

export default MenuProgramacao;
